import { authSlice } from "./auth/authSlice";
import { combineReducers } from "redux";
import { companiesSlice } from "./companies/companiesSlice";
import { contentSlice } from "./content/ContentSlice";
import { invoicesSlice } from "./invoices/invoicesSlice";
import { dashboardSlice } from "./dashboard/dashboardSlice";

export const reducer = combineReducers({
  auth: authSlice.reducer,
  companies: companiesSlice.reducer,
  content: contentSlice.reducer,
  invoices: invoicesSlice.reducer,
  dashboard: dashboardSlice.reducer,
});
